import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { Link, useHistory } from 'react-router-dom';
import * as R from 'ramda';
import countriesList from 'iso-3166-1-alpha-2';

import celibataireW from './../../assets/images/svg/001-W-celibataire.svg';
import unionsW from './../../assets/images/svg/001-W-unions.svg';
import divorceeW from './../../assets/images/svg/001-W-divorcee.svg';
import veuveW from './../../assets/images/svg/001-W-veuve.svg';

import celibataireM from './../../assets/images/svg/001-M-celibataire.svg';
import unionsM from './../../assets/images/svg/001-M-unions.svg';
import divorceeM from './../../assets/images/svg/001-M-divorcee.svg';
import veuveM from './../../assets/images/svg/001-M-veuve.svg';

import children from './../../assets/images/svg/002-children.svg';
import noChildren from './../../assets/images/svg/002-nochildren.svg';
import appartement from './../../assets/images/svg/090-flats.svg';
import maison from './../../assets/images/svg/069-home.svg';
import palace from './../../assets/images/svg/093-palace.svg';
import hotel from './../../assets/images/svg/087-hotel.svg';
import peniche from './../../assets/images/svg/091-house-2.svg';
import divers from './../../assets/images/svg/092-camping-tent.svg';
import residenceSenior from "./../../assets/images/svg/147-senior-residence.svg";
import retraite from './../../assets/images/svg/111-rocking-chair.png';
import activite from './../../assets/images/svg/035-id-card.svg';
import pole from './../../assets/images/svg/066-job-interview.svg';
import autre from './../../assets/images/svg/034-clipboard.svg';
import { RegexFields } from '../../constants/utils/regexFields';
import { updateUser, addUserAddress, updateAddress, updateOnBoardingStep } from '../../actions/user-api';
import {ProfessionOptions} from '../../constants/utils/connectionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { DateWithModal } from '../dateWithModal';
import { DepartamentsList } from './departamentsList';
import countryTelData from 'country-telephone-data';
import { DeleteModal } from './deleteModal';
import * as Loadings from '../../constants/loadings/user';
import queryString from 'query-string';

export const Personal = ({ personalDataRequirements, setPersonalDataRequirements, isSettings, setSelectedGender, inModal }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const dispatch = useDispatch();
    // const credentialsForm = useRef(null);
    const history = useHistory();
    const civilForm = useRef(null);
    const familyForm = useRef(null);
    const childrenForm = useRef(null);
    const assetForm = useRef(null);
    const professionForm = useRef(null);

    const router = useSelector(state => state.router);
    const user = useSelector(state => state.user);
    const [wasValidated, setWasValidated] = useState(false);
    // const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
    const [credentials, setCredentials] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        phoneNumber: '',
        otpCode: '',
        countryCode: '+33'
    });

    function updateCredentials() {
        let number = undefined;
        let dialCode = undefined;

        if (!R.isNil(user.user) && !R.isNil(user.user.phoneNumber) && user.user.phoneNumber !== '') {
            let i = 1;
            let tmpPhone = user.user.phoneNumber.slice(1);
            while (R.isNil(dialCode) && i < tmpPhone.length) {
                let country = countryTelData.allCountries.find(c => c.dialCode === tmpPhone.slice(0, i));
                if (!R.isNil(country)) {
                    dialCode = country.dialCode;
                }
                i++;
            }

            number = tmpPhone.slice(dialCode.length);
        }
        setCredentials({
            ...credentials, email: !R.isNil(user.user) && !R.isNil(user.user.email) && user.user.email !== '' ? user.user.email : '',
            phoneNumber: !R.isNil(number) ? number.replace(/\B(?=(\d{3})+(?!\d))/g, " ") : '',
            countryCode: !R.isNil(dialCode) ? '+' + dialCode : '+33'
        });
    }

    //civil
    const [personalData, setPersonalData] = useState({
        gender: !R.isNil(user.user) && !R.isNil(user.user.gender) ? user.user.gender : undefined,
        firstName: !R.isNil(user.user) && !R.isNil(user.user.firstName) ? user.user.firstName : '',
        lastName: !R.isNil(user.user) && !R.isNil(user.user.lastName) ? user.user.lastName : '',
        birthDate: !R.isNil(user.user) && !R.isNil(user.user.birthDate) ? user.user.birthDate : undefined,
        birthPlace: !R.isNil(user.user) && !R.isNil(user.user.birthPlace) ? user.user.birthPlace : '',
        depNumber: !R.isNil(user.user) && !R.isNil(user.user.departmentNumber) ? user.user.departmentNumber : '',
        country: !R.isNil(user.user) && !R.isNil(user.user.country) && user.user.country !== '' ? user.user.country : 'FR'
    });

    //contact
    const [asset, setAsset] = useState({
        address: !R.isNil(user.address) && !R.isNil(user.address.addressLine1) ? user.address.addressLine1 : '',
        type: !R.isNil(user.address) && !R.isNil(user.address.addressContract) ? user.address.addressContract : undefined,
        estateType: !R.isNil(user.address) && !R.isNil(user.address.addressType) ? user.address.addressType : undefined,
        city: !R.isNil(user.address) && !R.isNil(user.address.city) ? user.address.city : '',
        country: !R.isNil(user.address) && !R.isNil(user.address.country) ? user.address.country : 'FR',
        zipCode: !R.isNil(user.address) && !R.isNil(user.address.postalCode) ? user.address.postalCode : '',
        phone: !R.isNil(user.address) && !R.isNil(user.address.phoneNumber) ? user.address.phoneNumber : '',
        //   mobile: !R.isNil(user.user) && !R.isNil(user.user) ? user.user.phoneNumber : ''
    });

    //family
    const [family, setFamily] = useState(!R.isNil(user.user) && !R.isNil(user.user.civilStatus) ? user.user.civilStatus : undefined);

    //children
    const [childrenSelected, setChildrenSelected] = useState(!R.isNil(user.user) && !R.isNil(user.user.hasChildren) ? user.user.hasChildren : undefined);

    //profession
    const [professionSelected, setProfessionSelected] = useState(!R.isNil(user.user) && !R.isNil(user.user.professionalSituation) ? user.user.professionalSituation : []);

    const familyStatusText = {
        married: { 'Male': 'Marié', 'Female': 'Mariée' },
        divorced: { 'Male': 'Divorcé', 'Female': 'Divorcée' },
        widow: { 'Male': 'Veuf', 'Female': 'Veuve' },
        civilUnion: { 'Male': 'Pacsé', 'Female': 'Pacsée' }
    };

    //#region etat civil
    const gender = { male: 'Male', female: 'Female' };

    function isCompleteSectionCivil() {
        let isFrance = personalData.country === 'FR' || personalData.country === 'GF' || personalData.country === 'PF' || personalData.country === 'TF' || personalData.country === null;
        let skipSet = false;
        if (personalData.firstName !== '' && personalData.lastName !== '' && personalData.birthDate !== undefined && personalData.gender !== undefined && personalDataRequirements.civil === false) {
            if (isFrance && (personalData.depNumber === '' || personalData.birthPlace === '')) {
                skipSet = true;
            }
            if (skipSet === false) {
                setPersonalDataRequirements({ ...personalDataRequirements, civil: true });
            }
        }
        else if ((personalData.firstName === '' || personalData.lastName === '' || personalData.birthDate === undefined || personalData.gender === undefined || (isFrance && (personalData.depNumber === '' || personalData.birthPlace === ''))) && personalDataRequirements.civil === true) {
            setPersonalDataRequirements({ ...personalDataRequirements, civil: false });
        }
    }
    //#endregion

    //#region family
    const familyOptions = { celibataire: 'Single', mariee: 'Married', divorcee: 'Divorced', veuve: 'Widowed', libre: 'FreeUnion', civilUnion: 'CivilUnion' };
    function isCompleteSectionFamily() {
        if (family !== undefined && personalDataRequirements.familiar === false) {
            setPersonalDataRequirements({ ...personalDataRequirements, familiar: true });
        }
    }
    //#endregion

    //#region children
    const childrenOptions = { noChildren: false, hasChildren: true };
    function isCompleteSectionChildren() {
        if (childrenSelected !== undefined && personalDataRequirements.children === false) {
            setPersonalDataRequirements({ ...personalDataRequirements, children: true });
        }
    }
    //#endregion

    //#region contact
    const assetTypeOptions = { owner: 'Owner', tenant: 'Tenant', other: 'Other' };
    const estateType = { appartement: "Apartment", house: "House", castle: "Castle", hotel: "Hotel", boat: "Houseboat", camp: "Other", seniorResidence: "SeniorResidence" };
    function isCompleteSectionContact() {
        let assetNotNull = !R.isNil(asset) && !R.isNil(asset.type) && !R.isNil(asset.estateType) &&
            asset.address !== '' && asset.zipCode !== '' && asset.city !== '' && asset.country !== '';
        if (assetNotNull === true && personalDataRequirements.contact === false) {
            setPersonalDataRequirements({ ...personalDataRequirements, contact: true });
        }
        else if (assetNotNull === false && personalDataRequirements.contact === true) {
            setPersonalDataRequirements({ ...personalDataRequirements, contact: false });
        }
    }
    //#endregion

    //#region profession
    function isCompleteSectionProfession() {
        if (professionSelected.length !== 0 && personalDataRequirements.profession === false) {
            setPersonalDataRequirements({ ...personalDataRequirements, profession: true });
        }
        else if (professionSelected.length === 0 && personalDataRequirements.profession === true) {
            setPersonalDataRequirements({ ...personalDataRequirements, profession: false });
        }
    }
    //#endregion

    useEffect(() => {
        if (isSettings === undefined) {
            isCompleteSectionCivil();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personalData]);

    useEffect(() => {
        if (isSettings === undefined) {
            isCompleteSectionFamily();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [family]);

    useEffect(() => {
        if (isSettings === undefined) {
            isCompleteSectionChildren();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [childrenSelected]);

    useEffect(() => {
        if (isSettings === undefined) {
            isCompleteSectionProfession();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [professionSelected]);

    useEffect(() => {
        if (isSettings === undefined) {
            isCompleteSectionContact();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [asset]);

    useEffect(() => {
        if (!R.isNil(user.user)) {
            let firstName = user.user.firstName;
            let lastName = user.user.lastName;
            const parsedQueryString = queryString.parse(window.location.search);
            if(!R.isNil(parsedQueryString.acr_values) && parsedQueryString.acr_values.startsWith("signup:")){
                const token = parsedQueryString.acr_values.replace("signup:", "");
                const tokenParts = token.split(".");
                if(tokenParts.length === 3){
                    const tokenPayloadString = atob(decodeURI(tokenParts[1]));
                    const tokenPayload = JSON.parse(tokenPayloadString);
                    firstName = tokenPayload.FirstName;
                    lastName = tokenPayload.LastName;
                }
            }
            setPersonalData({
                ...personalData,
                gender: user.user.gender,
                firstName: firstName,
                lastName: lastName,
                birthDate: user.user.birthDate,
                birthPlace: user.user.birthPlace,
                depNumber: user.user.departmentNumber,
                country: user.user.country
            });
            setFamily(user.user.civilStatus);
            setChildrenSelected(!R.isNil(user.user.hasChildren) ? user.user.hasChildren : undefined);
            setProfessionSelected(R.isNil(user.user.professionalSituation) ? [] : user.user.professionalSituation);
            // dispatch(getUserAddress(tmpUser.id));
        }
        updateCredentials();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.user]);

    useEffect(() => {
        if (!R.isNil(user.address)) {
            setAsset({
                ...asset,
                address: user.address.addressLine1,
                type: user.address.addressContract,
                estateType: user.address.addressType,
                city: user.address.city,
                country: user.address.country,
                zipCode: user.address.postalCode,
                phone: user.address.phoneNumber
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.address]);

    useEffect(() => {
        if (isSettings === undefined) {
            isCompleteSectionCivil();
            isCompleteSectionFamily();
            isCompleteSectionChildren();
            isCompleteSectionContact();
            isCompleteSectionProfession();
        }
    });

    useEffect(() => {
        if (isSettings === undefined) {
            setSelectedGender(personalData.gender);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personalData]);

    useEffect(() => {
        if (isSettings === true && credentials.phoneNumber === '' && !R.isNil(user.user)) {
            updateCredentials();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [!R.isNil(user.user) && user.user.phoneNumber]);

    function scrollToFirstInvalid() {
        const nodes = window.document.querySelectorAll('.was-validated .form-control:invalid');
        if (!R.isNil(nodes) && nodes.length > 0) {
            // let nodesNotHidden = nodes.find(n => !n.classList.includes('hidden'));
            nodes[0].scrollIntoView({ behavior: 'smooth' });
        }
    }
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);
    let etatCivilSection = <section className="block">
        <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-0">ETAT CIVIL</h4>
        <form className="py-sm" noValidate ref={civilForm}>
            <div className="form-inline mb-3">
                <div className="custom-control custom-radio custom-control-inline mr-6">
                    <input required type="radio" id="Madame" name="SexMadameMonsieur" className="custom-control-input" checked={personalData.gender === gender.female} onChange={(e) => {
                        setPersonalData({ ...personalData, gender: gender.female });
                    }} />
                    <label className="custom-control-label" htmlFor="Madame">Madame</label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="Monsieur" name="SexMadameMonsieur" className="custom-control-input" checked={personalData.gender === gender.male} onChange={(e) => {
                        setPersonalData({ ...personalData, gender: gender.male });
                    }} />
                    <label className="custom-control-label" htmlFor="Monsieur">Monsieur</label>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col col-xl-4">
                    <label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">Prénom *</label>
                    <input required type="text" className="form-control" id="Prenom" defaultValue={personalData.firstName} onChange={(e) => {
                        e.preventDefault();
                        setPersonalData({ ...personalData, firstName: e.target.value });
                    }} pattern={RegexFields.nameWithoutNumbers} />
                </div>
                <div className="form-group col col-xl-4">
                    <label className="h6 font-weight-bolder my-auto" htmlFor="Nom">Nom *</label>
                    <input required type="text" className="form-control" id="Nom" defaultValue={personalData.lastName} onChange={(e) => {
                        e.preventDefault();
                        setPersonalData({ ...personalData, lastName: e.target.value });
                    }} pattern={RegexFields.nameWithoutNumbers} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-12 col-sm col-xl">
                    <label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de naissance *</label>
                    <DateWithModal isRequired={true} selectedDate={personalData.birthDate} setSelectedDate={(d) => setPersonalData({ ...personalData, birthDate: d })} />
                </div>
                <div className="form-group col-12 col-sm col-xl">
                    {/* <label className="h6 font-weight-bolder my-auto" htmlFor="Commune">Commune de naissance {personalData.country === 'FR' ? '*': ''}</label> */}
                    {
                        personalData.country === 'FR' || personalData.country === 'GF' || personalData.country === 'PF' || personalData.country === 'TF' || personalData.country === null ?
                            <label className="h6 font-weight-bolder my-auto" htmlFor="Commune">Commune de naissance *</label>
                            :
                            <label className="h6 font-weight-bolder my-auto" htmlFor="Commune">Commune de naissance</label>
                    }
                    <input required={personalData.country === 'FR' || personalData.country === 'GF' || personalData.country === 'PF' || personalData.country === 'TF' || personalData.country === null ? true : false} type="text" className="form-control" id="Commune" defaultValue={personalData.birthPlace} onChange={
                        (e) => {
                            e.preventDefault();
                            setPersonalData({ ...personalData, birthPlace: e.target.value });
                        }
                    } pattern={RegexFields.nameWithoutNumbers} />
                </div>
                <div className={(inModal === undefined ? 'd-none' : 'w-100 d-lg-none')}></div>
                <div className={"form-group col-12 col-sm" + (inModal === undefined ? ' col-xl' : '')}>
                    {
                        personalData.country === 'FR' || personalData.country === 'GF' || personalData.country === 'PF' || personalData.country === 'TF' || personalData.country === null ?
                            <label className="h6 font-weight-bolder my-auto" htmlFor="Pays">Nº de département *</label>
                            :
                            <label className="h6 font-weight-bolder my-auto" htmlFor="Pays">Nº de département</label>
                    }
                    <select required={personalData.country === 'FR' || personalData.country === 'GF' || personalData.country === 'PF' || personalData.country === 'TF' || personalData.country === null ? true : false} disabled={personalData.country !== 'FR' && personalData.country !== null} className="custom-select" id="naturalite" value={personalData.depNumber} onChange={(event) => {
                        setPersonalData({ ...personalData, depNumber: event.target.value });
                    }}>
                        {
                            DepartamentsList.map((country, index) => {
                                return (
                                    <option key={index} value={country}>{country}</option>
                                );
                            })
                        }
                    </select>
                </div>
                <div className={"form-group col-12 col-sm" + (inModal === undefined ? ' col-xl' : '')}>
                    <label className="h6 font-weight-bolder my-auto" htmlFor="naturalite">Pays *</label>
                    <select className="custom-select" id="naturalite" value={personalData.country} onChange={(event) => {
                        setPersonalData({ ...personalData, country: event.target.value });
                    }}>
                        {
                            Object.keys(countriesList.getData()).map((country, index) => {
                                return (
                                    <option key={index} value={country}>{countries.getName(country, "fr", { select: "official" })}</option>
                                );
                            })
                        }
                    </select>
                </div>
            </div>
        </form>
    </section>;
    let otherSections = (
			<React.Fragment>
				<section className="block mt-2 pt-2">
					<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">SITUATION FAMILIALE *</h4>
					{/* Change source for all images according to Gender (ex: from celibataireW to celibataireM) */}
					<form className="py-sm" noValidate ref={familyForm}>
						<div className="form-row">
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setFamily(familyOptions.celibataire);
								}}>
								<div className={"card card-body text-center picker-card" + (family === familyOptions.celibataire ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={personalData.gender === gender.male ? celibataireM : celibataireW} alt="Célibataire" />
									<h2 className="h6 font-weight-bolder my-auto">Célibataire</h2>
								</div>
							</div>
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setFamily(familyOptions.mariee);
								}}>
								<div className={"card card-body text-center picker-card" + (family === familyOptions.mariee ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={personalData.gender === gender.male ? unionsM : unionsW} alt={familyStatusText.married[personalData.gender]} />
									<h2 className="h6 font-weight-bolder my-auto">{familyStatusText.married[personalData.gender]}</h2>
								</div>
							</div>
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setFamily(familyOptions.divorcee);
								}}>
								<div className={"card card-body text-center picker-card" + (family === familyOptions.divorcee ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={personalData.gender === gender.male ? divorceeM : divorceeW} alt={familyStatusText.divorced[personalData.gender]} />
									<h2 className="h6 font-weight-bolder my-auto">{familyStatusText.divorced[personalData.gender]}</h2>
								</div>
							</div>
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setFamily(familyOptions.veuve);
								}}>
								<div className={"card card-body text-center picker-card" + (family === familyOptions.veuve ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={personalData.gender === gender.male ? veuveM : veuveW} alt={familyStatusText.widow[personalData.gender]} />
									<h2 className="h6 font-weight-bolder my-auto">{familyStatusText.widow[personalData.gender]}</h2>
								</div>
							</div>
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setFamily(familyOptions.libre);
								}}>
								<div className={"card card-body text-center picker-card" + (family === familyOptions.libre ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={personalData.gender === gender.male ? unionsM : unionsW} alt="Union Libre" />
									<h2 className="h6 font-weight-bolder my-auto">Union Libre</h2>
								</div>
							</div>
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setFamily(familyOptions.civilUnion);
								}}>
								<div className={"card card-body text-center picker-card" + (family === familyOptions.civilUnion ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={personalData.gender === gender.male ? unionsM : unionsW} alt={familyStatusText.civilUnion[personalData.gender]} />
									<h2 className="h6 font-weight-bolder my-auto">{familyStatusText.civilUnion[personalData.gender]}</h2>
								</div>
							</div>
						</div>
						<div className={"invalid-feedback alert-danger alert" + (family === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
					</form>
				</section>
				<section className="block mt-2 pt-2">
					<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">enfants *</h4>
					<form className="py-sm" noValidate ref={childrenForm}>
						<div className="form-row">
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setChildrenSelected(childrenOptions.hasChildren);
								}}>
								<div className={"card card-body text-center picker-card" + (childrenSelected === childrenOptions.hasChildren ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={children} alt="oui" />
									<h2 className="h6 font-weight-bolder my-auto">{router.location.pathname !== `/auth/partner` ? `J'ai des enfants` : `il/elle avait des enfants`}</h2>
								</div>
							</div>
							<div
								className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}
								onClick={() => {
									setChildrenSelected(childrenOptions.noChildren);
								}}>
								<div className={"card card-body text-center picker-card" + (childrenSelected === childrenOptions.noChildren ? " active" : "")}>
									<img className="img-fluid mx-auto my-3 mb-2 h-6" src={noChildren} alt="none" />
									<h2 className="h6 font-weight-bolder my-auto">{router.location.pathname !== `/auth/partner` ? `Je n'ai pas d'enfants` : `il/elle n’avait pas d’enfant`}</h2>
								</div>
							</div>
						</div>
						<div className={"invalid-feedback alert-danger alert" + (childrenSelected === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
					</form>
				</section>
				<section className="block mt-2 pt-2">
					<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">COORDONNÉES *</h4>
					<form className="py-sm" noValidate ref={assetForm}>
						<div className="d-block mb-3">
							<h5 className="h5 text-uppercase font-weight-bolder mb-2">TYPE DE BIEN</h5>
							<div className="form-inline mb-4">
								<div className="custom-control custom-radio custom-control-inline mr-6">
									<input type="radio" id="Propriétaire" name="bientype" className="custom-control-input" checked={asset.type === assetTypeOptions.owner} onClick={() => setAsset({ ...asset, type: assetTypeOptions.owner })} />
									<label className="custom-control-label" htmlFor="Propriétaire">
										Propriétaire
									</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline mr-6">
									<input type="radio" id="Locataire" name="bientype" className="custom-control-input" checked={asset.type === assetTypeOptions.tenant} onClick={() => setAsset({ ...asset, type: assetTypeOptions.tenant })} />
									<label className="custom-control-label" htmlFor="Locataire">
										Locataire
									</label>
								</div>
								<div className="custom-control custom-radio custom-control-inline">
									<input type="radio" id="Autre" name="bientype" className="custom-control-input" checked={asset.type === assetTypeOptions.other} onClick={() => setAsset({ ...asset, type: assetTypeOptions.other })} />
									<label className="custom-control-label" htmlFor="Autre">
										Autre
									</label>
								</div>
							</div>
							<div className={"invalid-feedback alert-danger alert" + (asset.type === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
						</div>
						<div className="d-block mb-3">
							<h5 className="h5 text-uppercase font-weight-bolder mb-2">type de bien immobilier</h5>
							<div className="form-row">
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}>
									<div className={"card card-body text-center picker-card" + (asset.estateType === estateType.appartement ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: estateType.appartement })}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={appartement} alt="appartement" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Appartement</h2>
									</div>
								</div>
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}>
									<div className={"card card-body text-center picker-card" + (asset.estateType === estateType.house ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: estateType.house })}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={maison} alt="maison" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Maison</h2>
									</div>
								</div>
								{/* <div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}>
									<div className={"card card-body text-center picker-card" + (asset.estateType === estateType.castle ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: estateType.castle })}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={palace} alt="palace" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">château</h2>
									</div>
								</div> */}
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}>
									<div className={"card card-body text-center picker-card" + (asset.estateType === estateType.seniorResidence ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: estateType.seniorResidence })}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={residenceSenior} alt="senior residence" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Résidence Senior</h2>
										<p className="small o-50 mt-0 mb-auto lh-copy">EHPAD, maison de retraite...</p>
									</div>
								</div>
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}>
									<div className={"card card-body text-center picker-card" + (asset.estateType === estateType.hotel ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: estateType.hotel })}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={hotel} alt="hotel" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Hôtel</h2>
									</div>
								</div>
								{/* <div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}>
									<div className={"card card-body text-center picker-card" + (asset.estateType === estateType.boat ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: estateType.boat })}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={peniche} alt="peniche" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Péniche</h2>
									</div>
								</div> */}
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3")}>
									<div className={"card card-body text-center picker-card" + (asset.estateType === estateType.camp || asset.estateType === estateType.castle || asset.estateType === estateType.boat ? " active" : "")} onClick={() => setAsset({ ...asset, estateType: estateType.camp })}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={divers} alt="divers" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">divers</h2>
										<p className="small o-50 mt-0 mb-auto lh-copy">Péniche, château...</p>
									</div>
								</div>
								<div className={"invalid-feedback alert-danger alert" + (asset.estateType === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
							</div>
							<div className="form-row">
								<div className="form-group col-12 col-sm-6">
									<div className="flex-row gx-2 align-items-center mb-1">
										<label className="h6 font-weight-bolder my-auto" htmlFor="Adresse">
											Adresse
										</label>
										{/* <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p> */}
									</div>
									<input
										required
										type="text"
										className="form-control"
										id="Adresse"
										defaultValue={asset.address}
										onChange={(event) => {
											setAsset({ ...asset, address: event.target.value });
										}}
									/>
								</div>
								<div className="form-group col-12 col-sm col-xl">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Postal">
										Code Postal
									</label>
									{asset.country === null || asset.country === "FR" || asset.country === "GF" || asset.country === "PF" || asset.country === "TF" ? (
										<input
											required
											type="text"
											className="form-control"
											id="Postal"
											value={asset.zipCode}
											onChange={(event) => {
												setAsset({ ...asset, zipCode: event.target.value });
											}}
											pattern={RegexFields.frenchZipCode}
										/>
									) : (
										<input
											required
											type="text"
											className="form-control"
											id="Postal"
											value={asset.zipCode}
											onChange={(event) => {
												setAsset({ ...asset, zipCode: event.target.value });
											}}
										/>
									)}
								</div>
								<div className="form-group col-12 col-sm col-xl">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Ville">
										Ville
									</label>
									<input
										required
										type="text"
										className="form-control"
										id="Ville"
										defaultValue={asset.city}
										onChange={(event) => {
											setAsset({ ...asset, city: event.target.value });
										}}
										pattern={RegexFields.nameWithoutNumbers}
									/>
								</div>
								<div className="form-group col-12 col-sm col-xl">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Pays">
										Pays
									</label>
									<select
										className="custom-select"
										id="naturalite"
										value={asset.country}
										onChange={(event) => {
											setAsset({ ...asset, country: event.target.value });
										}}>
										{Object.keys(countriesList.getData()).map((country, index) => {
											return (
												<option key={index} value={country}>
													{countries.getName(country, "fr", { select: "official" })}
												</option>
											);
										})}
									</select>
								</div>
							</div>
							<div className="form-row">
								<div className="form-group col-12 col-lg-3">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Téléphone">
										Téléphone fixe
									</label>
									<input
										type="tel"
										className="form-control"
										id="Téléphone"
										placeholder="00 00 00 00 00"
										defaultValue={asset.phone}
										onChange={(event) => {
											setAsset({ ...asset, phone: event.target.value });
										}}
										pattern={RegexFields.frenchPhoneNumber}
									/>
								</div>
								{/* <div className="form-group col-12 col-lg-3">
                        <label className="h6 font-weight-bolder my-auto" htmlFor="mobile">Téléphone mobile</label>
                        <input type="tel" className="form-control" id="mobile" placeholder="00 00 00 00 00" defaultValue={asset.mobile} required onChange={(event) => {
                            setAsset({ ...asset, mobile: event.target.value })
                        }} pattern={RegexFields.frenchPhoneNumber} />
                    </div> */}
							</div>
						</div>
					</form>
				</section>
				<section className="block mt-2 pt-2">
					<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">Situation Professionnelle *</h4>
					<form className={inModal === undefined ? "py-sm" : "block"} noValidate ref={professionForm}>
						<div className={"d-block" + (inModal === undefined ? " mb-3" : " mt-3")}>
							{router.location.pathname !== `/auth/partner` ? <h5 className="h5 text-uppercase font-weight-bolder mb-2">JE SUIS</h5> : ""}
							<div className="form-row">
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3 mb-0")}>
									<div
										className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.retired) ? " active" : "")}
										onClick={() => {
											if (!professionSelected.includes(ProfessionOptions.retired) && !professionSelected.includes(ProfessionOptions.unemployed) && !professionSelected.includes(ProfessionOptions.none)) {
												setProfessionSelected([...professionSelected, ProfessionOptions.retired]);
											} else {
												setProfessionSelected(professionSelected.filter((p) => p !== ProfessionOptions.retired));
											}
										}}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={retraite} alt="retraite" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">RETRAITÉ(E)</h2>
									</div>
								</div>
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3 mb-0")}>
									<div
										className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.active) ? " active" : "")}
										onClick={() => {
											if (!professionSelected.includes(ProfessionOptions.active) && !professionSelected.includes(ProfessionOptions.unemployed) && !professionSelected.includes(ProfessionOptions.none)) {
												setProfessionSelected([...professionSelected, ProfessionOptions.active]);
											} else {
												setProfessionSelected(professionSelected.filter((p) => p !== ProfessionOptions.active));
											}
										}}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={activite} alt="activite" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">EN ACTIVITÉ(E)</h2>
									</div>
								</div>
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3 mb-0")}>
									<div
										className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.unemployed) ? " active" : "")}
										onClick={() => {
											if (!professionSelected.includes(ProfessionOptions.unemployed) && !professionSelected.includes(ProfessionOptions.active) && !professionSelected.includes(ProfessionOptions.retired) && !professionSelected.includes(ProfessionOptions.none)) {
												setProfessionSelected([...professionSelected, ProfessionOptions.unemployed]);
											} else {
												setProfessionSelected(professionSelected.filter((p) => p !== ProfessionOptions.unemployed));
											}
										}}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={pole} alt="pole" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">À FRANCE TRAVAIL</h2>
									</div>
								</div>
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3 mb-0")}>
									<div
										className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.other) ? " active" : "")}
										onClick={() => {
											if (!professionSelected.includes(ProfessionOptions.other) && !professionSelected.includes(ProfessionOptions.none)) {
												setProfessionSelected([...professionSelected, ProfessionOptions.other]);
											} else {
												setProfessionSelected(professionSelected.filter((p) => p !== ProfessionOptions.other));
											}
										}}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={autre} alt="autre" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">AUTRE ACTIVITÉ</h2>
									</div>
								</div>
								<div className={"form-group col col-lg-4" + (inModal === undefined ? " col-xl-2" : " col-xl-3 mb-0")}>
									<div
										className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.none) ? " active" : "")}
										onClick={() => {
											if (!professionSelected.includes(ProfessionOptions.none)) {
												setProfessionSelected([ProfessionOptions.none]);
											} else {
												setProfessionSelected(professionSelected.filter((p) => p !== ProfessionOptions.none));
											}
										}}>
										<img className="img-fluid mx-auto my-3 mb-2 h-6" src={maison} alt="autre" />
										<h2 className="h6 font-weight-bolder text-uppercase mb-auto">SANS ACTIVITÉ</h2>
									</div>
								</div>
								<div className={"invalid-feedback alert-danger alert" + (professionSelected.length === 0 && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
							</div>
						</div>
					</form>
				</section>
			</React.Fragment>
		);

    return (
        <div className={isSettings === undefined ? "auto-view py-4 py-lg-0 mt-lg-sm" : inModal === undefined ? "auto-view py-3 pb-lg-0" : ""}>
            {
                isSettings === undefined ?
                    <div className="container-fluid">
                        {etatCivilSection}
                        {personalData.gender === undefined ? '' : otherSections}
                    </div>
                    :
                    inModal === undefined ?

                        <div className="container-fluid">
                            {/* <h2 className="sr-only visually-hidden">Settings: Profil</h2> */}
                            {/* <Profile passwordRequirements={passwordRequirements} setPasswordRequirements={setPasswordRequirements} registerPage={false}
                                credentials={credentials} setCredentials={setCredentials} credentialsForm={credentialsForm} wasValidated={wasValidated} setWasValidated={setWasValidated} isSettings={isSettings} /> */}
                            {/* <h3 className="h3 font-weight-bold mb-4">Mes données</h3> */}
                            {etatCivilSection}
                            {personalData.gender === undefined ? '' : otherSections}

                            <DeleteModal />
                        </div>

                        : <React.Fragment>
                            {etatCivilSection}
                            {personalData.gender === undefined ? '' : otherSections}
                        </React.Fragment>
            }
            {
                inModal === undefined ?
                    <div className="container-fluid">
                        <footer className={"flex-md-row align-items-center mt-auto w-100" + (isSettings === undefined ? ' mb-sm' : '')}>
                            {isSettings === undefined ? <Link to={"/auth/signup/step1" + (window.location.search !== '' ? window.location.search : '')} className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link> : ''}
                            <button className={isSettings === undefined ? "btn btn-info loading-btn px-md-gutter px-4" + (user.isLoading.includes(Loadings.UPDATE_USER) ? ' show' : '') : "btn btn-info loading-btn" + (user.isLoading.includes(Loadings.UPDATE_USER) ? ' show' : '')}
                                disabled={user.isLoading.includes(Loadings.UPDATE_USER)}
                                onClick={(event) => {
                                    event.preventDefault();
                                    let formsAreNotNull = !R.isNil(childrenForm.current) && !R.isNil(familyForm.current) && !R.isNil(assetForm) && !R.isNil(professionForm);
                                    if (formsAreNotNull && civilForm.current.checkValidity() && assetForm.current.checkValidity() && familyForm.current.checkValidity() && childrenForm.current.checkValidity() && professionSelected.length !== 0 && asset.estateType !== undefined && asset.type !== undefined) {
                                        let userToUpdate = {
                                            id: user.user.id,
                                            gender: personalData.gender,
                                            firstName: personalData.firstName,
                                            lastName: personalData.lastName,
                                            birthDate: personalData.birthDate,
                                            birthPlace: personalData.birthPlace,
                                            departmentNumber: personalData.depNumber,
                                            country: personalData.country === null ? 'FR' : personalData.country,
                                            civilStatus: family,
                                            hasChildren: childrenSelected,
                                            professionalSituation: professionSelected.join(','),
                                            // phoneNumber: asset.mobile,
                                            processNumber: user.user.processNumber
                                        };
                                        if (isSettings === true && credentials.password !== '' && credentials.password === credentials.confirmPassword) {
                                            userToUpdate.currentPassword = credentials.currentPassword;
                                            userToUpdate.newPassword = credentials.password;
                                        }
                                        dispatch(updateUser(userToUpdate))
                                            .then(() => {
                                                let address = {
                                                    user: { id: user.user !== undefined ? user.user.id : undefined },
                                                    addressContract: asset.type,
                                                    addressType: asset.estateType,
                                                    addressLine1: asset.address,
                                                    postalCode: asset.zipCode,
                                                    city: asset.city,
                                                    country: asset.country,
                                                    phoneNumber: asset.phone
                                                };
                                                if (!R.isNil(user.address)) {
                                                    address.id = user.address.id;
                                                    dispatch(updateAddress(address));

                                                }
                                                else {
                                                    dispatch(addUserAddress(address));
                                                }
                                            }).then(() => {
                                                if (isSettings === undefined) {
                                                    dispatch(updateOnBoardingStep(2));
                                                    history.push("/auth/signup/step3" + (window.location.search !== '' ? window.location.search : ''));
                                                }
                                            });
                                    }
                                    civilForm.current.classList.add('was-validated');
                                    if (formsAreNotNull === true) {
                                        childrenForm.current.classList.add('was-validated');
                                        familyForm.current.classList.add('was-validated');
                                        assetForm.current.classList.add('was-validated');
                                        professionForm.current.classList.add('was-validated');
                                    }
                                    // if (isSettings === true) {
                                    //     credentialsForm.current.classList.add('was-validated');
                                    // }
                                    setWasValidated(true);
                                    scrollToFirstInvalid();
                                }}>{isSettings === undefined ? "Passer à l'étape suivante" : "Sauvegarder"}<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                            {/* <Link to="/auth/signup/step2a" className="btn btn-info px-md-gutter px-4">Passer à l'étape suivante</Link> */}
                            <h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
                        </footer>
                    </div>
                    : ''
            }
        </div>
    );
};